<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { api, setCsrfToken } from '../../services/api'

const route = useRoute()
const router = useRouter()
const links = [
  ['Overview', '/admin', '⌂'],
  ['Quotes', '/admin/quotes', '❝'],
  ['Bottles', '/admin/bottles', '◇'],
  ['Comments', '/admin/comments', '✎'],
  ['Reports', '/admin/reports', '!'],
  ['Moderation', '/admin/moderation', '✦'],
  ['AI settings', '/admin/settings/ai', '⚙'],
] as const

function active(path: string) {
  return path === '/admin' ? route.path === path : route.path.startsWith(path)
}

async function logout() {
  await api('/admin/auth/logout', { method: 'POST' })
  setCsrfToken(null)
  await router.push('/admin/login')
}
</script>

<template>
  <div class="admin-app">
    <aside class="admin-sidebar">
      <RouterLink class="brand inverse" to="/admin"
        ><span class="brand-mark">✦</span><span>Wilson</span></RouterLink
      >
      <p class="sidebar-caption">Message in a Bottle</p>
      <nav>
        <RouterLink
          v-for="[label, path, icon] in links"
          :key="path"
          :to="path"
          :class="{ active: active(path) }"
          ><span>{{ icon }}</span
          >{{ label }}</RouterLink
        >
      </nav>
      <div class="sidebar-bottom">
        <RouterLink to="/">View public site ↗</RouterLink><button @click="logout">Sign out</button>
      </div>
    </aside>
    <main class="admin-main"><RouterView /></main>
  </div>
</template>
